var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisabledRedo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_27353",
    "data-name": "Path 27353",
    d: "M19.386,289.856,24.529,295l-5.143,5.143v-4.286h-12a5.143,5.143,0,1,0,0,10.286h5.143v1.714H7.386a6.857,6.857,0,1,1,0-13.714h12Z",
    transform: "translate(-0.529 -289.856)",
    fill: "#949494"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledRedo);
export default __webpack_public_path__ + "static/media/DisabledRedo.4cf09cae67c041213756d3044db79cf6.svg";
export { ForwardRef as ReactComponent };